<div *ngIf="visible">
  <div class="progress-loader">
    <div class="line"></div>
    <div class="subline inc"></div>
    <div class="subline dec"></div>
  </div>
</div>
